module.exports = __webpack_public_path__ + "img/ic_eskhata.ea777a80.png";